import Pikaday from 'pikaday';
import moment from 'moment';

import { $win, $header } from './utils';

const $booking = $('.booking');
const $bookingToggle = $('.js-booking-toggle');
const format = 'DD/MM/YYYY';

const toggleBookingMask = () => {
	$bookingToggle.on('click', function() {
		$booking.toggleClass('active');

		$header.removeClass('active');
	});
}

const togglePromoCode = () => {
	const $container = $('.promo');
	const $select = $container.find('#promo_code_select');
	const $content = $container.find('.promo__content');
	const $input = $content.find('#promo_code');

	$select.on('change', function() {
		const value = $(this).val();

		if (value != 0) {
			$container.addClass('active');
			$content.stop().slideDown(500);

			setTimeout(() => {
				$input[0].focus();
			}, 100);
		} else {
			$input.attr('name', '');
			$container.removeClass('active');
			$content.stop().slideUp(500);
			$input[0].blur();
		}
	});
}

const initBookingDaterangepicker = () => {
	const $datepickers = $('.js-datepicker');
	let isKeyboard = false;

	$datepickers.each((index, el) => {
		const fieldStart = el.querySelector('.js-datepicker-start');
		const fieldEnd = el.querySelector('.js-datepicker-end');
		const fieldStartContainer = fieldStart.parentNode;
		const fieldEndContainer = fieldEnd.parentNode;

		let minDate = $('body').data('bookFrom') || new Date();
		minDate = moment(minDate).toDate();

		let startDate, endDate;

		const today = moment(minDate).format("LLLL");
        const nextDay = moment(minDate).add('1','day').format("LLLL");

        $(fieldStart).attr('aria-label', today).val(moment().format(format));
        $(fieldEnd).attr('aria-label', nextDay).val(moment().add('1','day').format(format));

		const options = {
			minDate: minDate,
			numberOfMonths: 1,
			format,
			firstDay: 1,
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			i18n: {
				previousMonth : 'Previous Month',
				nextMonth     : 'Next Month',
				months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
				weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
				weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
			}
		}

		const toggleInputClass = (field) => {
			field.addEventListener('change', function() {
				this.value ? this.classList.add('has-value') : this.classList.remove('has-value');
			});
		}

		toggleInputClass(fieldStart);
		toggleInputClass(fieldEnd);

		const updateStartDate = () => {
			const newEndDate = moment(startDate, format).add(1, 'days');

            startPicker.setStartRange(startDate);
            startPicker.setEndRange(newEndDate._d);

            endPicker.setStartRange(newEndDate._d);
            endPicker.setEndRange(newEndDate._d);
            endPicker.setMinDate(newEndDate._d);
            endPicker.setMoment(newEndDate.format(format));
            endPicker.gotoDate(newEndDate.format(format));
            endPicker.gotoMonth(newEndDate.month());
            endPicker.gotoYear(newEndDate.year());

            $(fieldEnd).val(newEndDate.format(format));
		}

		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
            endPicker.setEndRange(endDate);
		}

		const startPicker = new Pikaday({
			field: fieldStart,
			container: fieldStartContainer,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					startDate = this.getDate();
					updateStartDate();

					setTimeout(function() {
						$(fieldEnd).focus();
					}, 10)
				}
			}
		});

		const endPicker = new Pikaday({
			field: fieldEnd,
			container: fieldEndContainer,
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					endDate = this.getDate();
					updateEndDate();
				}
			}
		});

		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();

		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}
	});
}

const initBookingDatepicker = () => {
	const $datepickers = $('.js-datepicker-single');
	let isKeyboard = false;

	$datepickers.each((index, el) => {
		const $datepicker = $(el);
		const field = el.querySelector('input');
		const fieldContainer = field.parentNode;

		const toggleInputClass = (field) => {
			field.addEventListener('change', function() {
				this.value ? this.classList.add('has-value') : this.classList.remove('has-value');
			});
		}

		toggleInputClass(field);

		const picker = new Pikaday({
			theme: 'pika-single-date',
			field,
			container: fieldContainer,
			minDate: new Date(),
			numberOfMonths: 1,
			format,
			firstDay: 1,
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			i18n: {
				previousMonth : 'Previous Month',
				nextMonth     : 'Next Month',
				months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
				weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
				weekdaysShort : ['S','M','T','W','T','F','S']
			}
		});
	});
}

export default function bookingUI() {
	initBookingDaterangepicker();

	initBookingDatepicker();

	toggleBookingMask();

	togglePromoCode();
}
